import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Job, JobPauseType, PauseJobRequest } from "@/types";

export function useUpdateJobPause() {
  const mutation = useMutation({
    // The union makes pauseReason and pauseType required exactly when pausing.
    // Unpause takes neither.
    mutationFn: async (
      variables:
        | {
            jobId: string;
            pause: true;
            pauseReason: string;
            pauseType: JobPauseType;
          }
        | { jobId: string; pause: false },
    ) => {
      const path = variables.pause
        ? `jobs/${variables.jobId}/pause`
        : `jobs/${variables.jobId}/unpause`;
      const res = await guacHttpClient.post<
        Job,
        HttpResponse<Job>,
        PauseJobRequest | undefined
      >(
        path,
        variables.pause
          ? {
              pauseReason: variables.pauseReason,
              pauseType: variables.pauseType,
            }
          : undefined,
      );

      return res.data;
    },
  });

  return mutation;
}
